var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-gallery"},_vm._l((_vm.images),function(image){return _c('a',{key:image.name,attrs:{"href":image.path,"target":"_blank"}},[_c('img',{attrs:{"src":image.path,"alt":image.name}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }